// extracted by mini-css-extract-plugin
module.exports = {"list":"Energy_list__2FEWp","infoLabel":"Energy_infoLabel__3T2LV","body":"Energy_body__3abNI"};